import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const featureSelector = createFeatureSelector('businesUnits');

export const getAvailabledRegions = createSelector(
  featureSelector,
  (f) => f?.regionsAndStores?.data?.availabledRegions ?? null,
);

export const getAvailabledStores = createSelector(
  featureSelector,
  (f) => f?.regionsAndStores?.data?.availabledStores ?? null,
);
